const basePath = "/";

export { basePath };